module.exports = __webpack_public_path__ + "img/empty-forum.8a02b749.svg";